import { render } from "./modal.vue?vue&type=template&id=28b77d44"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\inetpub\\wwwroot\\frontend\\employer-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__